(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game-app/views/partials/hammock_partial.js') >= 0) return;  svs.modules.push('/components/numbergames/game-app/views/partials/hammock_partial.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.numbergames=_svs.numbergames||{};
_svs.numbergames.game_app=_svs.numbergames.game_app||{};
_svs.numbergames.game_app.partials=_svs.numbergames.game_app.partials||{};
svs.numbergames.game_app.partials.hammock = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"number-games-content clearfix gutter-xs-1 gutter-md-2\">\n  "
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"content") || (depth0 != null ? lookupProperty(depth0,"content") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"content","hash":{},"data":data,"loc":{"start":{"line":2,"column":2},"end":{"line":2,"column":13}}}) : helper)))
    + "\n</div>\n";
},"useData":true});
Handlebars.partials['numbergames-game-app-hammock'] = svs.numbergames.game_app.partials.hammock;
})(svs, Handlebars);


 })(window);